export type TemplateId = string
export type VersionId = string
export type ItemId = string

export enum ApplicationType {
    AGENT = "Agent",
    CHANNEL = "Channel"
}

export enum ValueType {
    NUMBER = "Number",
    STRING = "String",
    BOOLEAN = "Boolean",
    SLOT = "Slot",
    PASSWORD = "Password",
    ARRAY = "Array",
    TEXT = "Text",
    OBJECT = "Object",
    AGENT = "Agent"
}

export type TypeFieldValue = {
    Case: ValueType
    Fields: string
}

interface Tab {
    Id: string
    Title: string
}

interface Group extends Tab {
    TabId: string
}

export interface Field {
    TabId: string
    GroupId: string
    Id: string
    Title: string
    Value: string
    TypeValue: TypeFieldValue
    IsRequired: boolean
}

export interface ApplicationSettings {
    Tabs: Tab[]
    Groups: Group[]
    Fields: Field[]
}

export enum ApplicationTemplateEntityType {
    AGENT = "Agent",
    CHANNEL = "Channel",
    SLOT = "Slot"
}

export interface EntityTemplate {
    EntityType: ApplicationTemplateEntityType
    Template: string
}

export enum VersionType {
    MAIN = "Main",
    SUB = "Sub"
}

export enum TemplateVersionStatus {
    DRAFT = "Draft",
    REVIEW = "Review",
    RELEASE = "Release",
    PUBLISH = "Publish",
    UNPUBLISH = "UnPublish"
}

export interface Version {
    Main: number
    Sub: number
}

export interface Audit {
    CreateTimestamp: number
    UpdateTimestamp: number
    DeleteTimestamp?: number
    CreateBy: string
    UpdateBy: string
    DeleteBy?: string
}
